import React, { Component } from "react";
import { Menu, Dropdown, Button } from "antd";
import {
  SettingOutlined,
  UserOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import Logout from "./Logout";
import ChangePassword from "./ChangePassword";

const LogoutLayout = () => {
 
  const menu = (
    <Menu >
      <Menu.Item key="1" icon={<LogoutOutlined />}>
        <ChangePassword />
      </Menu.Item>
      <Menu.Item key="2" icon={<SettingOutlined />}>
        <Logout />
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu}>
      <Button type="ghost" style={{ color: "white" }}>
        <UserOutlined /> Account
      </Button>
    </Dropdown>
  );
};

export default LogoutLayout;
